import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import ProjectCard from "./ProjectCard";

const PROJECTS = [
  {
    title: "Sheer Elegance",
    subtitle: "Residencia Premium",
    images: [
      "/images/persianas sheer elegance 1.jpeg",
      "/images/persianas sheer elegance 2.jpeg",
      "/images/persianas sheer elegance 3.jpeg",
      "/images/persianas sheer elegance 4.jpeg",
      "/images/persianas sheer elegance 5.jpeg",
      "/images/persianas sheer elegance 6.jpeg",
      "/images/persianas sheer elegance 7.jpeg",
      "/images/persianas sheer elegance 8.jpeg",
    ],
  },
  {
    title: "Persianas Enrollables",
    subtitle: "Recámara Moderna",
    images: [
      "/images/Persiana enrollable screen 1.jpeg",
      "/images/Persiana enrollable screen 2.jpeg",
      "/images/Persiana enrollable screen 3.jpeg",
      "/images/Persiana enrollable screen 4.jpeg",
      "/images/Persiana enrollable screen 5.jpeg",
    ],
  },
  {
    title: "Blackout",
    subtitle: "Máxima Privacidad",
    images: [
      "/images/Persiana enrollable black out.jpeg",
      "/images/Persiana enrollable black out 1.jpeg",
      "/images/Persiana enrollable black out 2.jpeg",
      "/images/Persiana enrollable black out 3.jpeg",
      "/images/Persiana enrollable black out 4.jpeg",
    ],
  },
  {
    title: "Lambrín Decorativo",
    subtitle: "Sala Contemporánea",
    images: [
      "/images/Lanbrim 1.jpeg",
      "/images/Lanbrim 2.jpeg",
      "/images/Lanbrim 3.jpeg",
      "/images/Lanbrim 4.jpeg",
    ],
  },
  {
    title: "Cortina Tradicional",
    subtitle: "Ambiente Elegante",
    images: [
      "/images/cortina tradicional 1.jpeg",
      "/images/cortina tradicional 2.jpeg",
      "/images/cortina tradicional 3.jpeg",
      "/images/cortina tradicional 4.jpeg",
      "/images/cortina tradicional 5.jpeg",
    ],
  },
  {
    title: "Otros Proyectos ",
    subtitle: "Otros Servicio",
    images: [
      "/images/pergola.jpeg",
      "/images/persiananoramal.jpeg",
      "/images/toldos.jpeg",
    ],
  },
];

export default function Gallery() {
  const [activeProject, setActiveProject] = useState(null);
  const [activeImage, setActiveImage] = useState(0);

  const openLightbox = (projectIndex) => {
    setActiveProject(projectIndex);
    setActiveImage(0);
  };

  const closeLightbox = () => {
    setActiveProject(null);
    setActiveImage(0);
  };

  const nextImage = () => {
    if (activeProject === null) return;

    setActiveImage(
      (prev) =>
        (prev + 1) %
        PROJECTS[activeProject].images.length
    );
  };

  const prevImage = () => {
    if (activeProject === null) return;

    setActiveImage(
      (prev) =>
        (prev - 1 + PROJECTS[activeProject].images.length) %
        PROJECTS[activeProject].images.length
    );
  };

  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="section bg-white"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-10">

        <div className="max-w-2xl mb-14 md:mb-20">
          <div className="eyebrow mb-5">
            NUESTROS PROYECTOS
          </div>

          <h2 className="font-display font-semibold text-persia-black text-3xl md:text-5xl leading-[1.1]">
            Proyectos{" "}
            <span className="italic font-light text-gold">
              Realizados
            </span>
          </h2>

          <p className="mt-5 text-persia text-base md:text-lg font-light">
            Hogares y oficinas transformados con persianas y cortinas a la medida.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {PROJECTS.map((project, index) => (
            <ProjectCard
              key={index}
              project={project}
              index={index}
              onOpen={() => openLightbox(index)}
            />
          ))}
        </div>
      </div>

      <AnimatePresence>
        {activeProject !== null && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeLightbox}
            className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center p-4"
          >
            <button
              onClick={(e) => {
                e.stopPropagation();
                closeLightbox();
              }}
              className="absolute top-6 right-6 text-white hover:text-gold"
            >
              <X size={30} />
            </button>

            <button
              onClick={(e) => {
                e.stopPropagation();
                prevImage();
              }}
              className="absolute left-6 text-white hover:text-gold"
            >
              <ChevronLeft size={40} />
            </button>

            <img
              src={PROJECTS[activeProject].images[activeImage]}
              alt={PROJECTS[activeProject].title}
              onClick={(e) => e.stopPropagation()}
              className="max-w-[90vw] max-h-[85vh] object-contain"
            />

            <button
              onClick={(e) => {
                e.stopPropagation();
                nextImage();
              }}
              className="absolute right-6 text-white hover:text-gold"
            >
              <ChevronRight size={40} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}